import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { Injectable } from '@angular/core';
import { EstimateConvertWorkOrderModel, EstimateRequestModel } from '@fs/models/estimate/estimate-request.model';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { CodeTypeModel } from '@fs/models/code-type.model';

@Injectable()
export class EstimateService {
    constructor(private auth: AuthService, private httpRepo: HttpRepo) {
        this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
    }

    PostEstimate(customerId: string, jobsiteId: string, data: EstimateRequestModel) {
        return this.httpRepo.Post(`customers/${customerId}/jobsites/${jobsiteId}/estimates`, data);
    }

    GetEstimate(customerId: string, jobsiteId: string, estimateId: string) {
        return this.httpRepo.Get(`customers/${customerId}/jobsites/${jobsiteId}/estimates/${estimateId}`);
    }

    PutEstimate(customerId: string, jobsiteId: string, estimateId: string, data: EstimateRequestModel) {
        return this.httpRepo.Put(`customers/${customerId}/jobsites/${jobsiteId}/estimates/${estimateId}`, data);
    }

    PrintEstimate(estimateId: string) {
        return this.httpRepo.GetFile("estimates/" + estimateId + "/print");
    }

    GetEstimates(state: DataSourceRequestState, searchKey:string) {
        return this.httpRepo.Get("estimates", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
    }
    GetJobSiteEstimates(jobsiteId: string, state: DataSourceRequestState, searchKey:string) {
        return this.httpRepo.Get("jobsites/" + jobsiteId + "/estimates", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
    }

    UpdateEstimateStatus(customerId: string, jobsiteId: string, estimateId: string, status: CodeTypeModel) {
        return this.httpRepo.Patch(`customers/${customerId}/jobsites/${jobsiteId}/estimates/${estimateId}`, status);
    }

    ConvertToWorkOrder(customerId: string, jobsiteId: string, estimateId: string, model: EstimateConvertWorkOrderModel) {
        return this.httpRepo.Post(`customers/${customerId}/jobsites/${jobsiteId}/estimates/${estimateId}/convert`, model);
    }
}